var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
var StyledLink = styled.a.attrs({
    role: 'link',
}).withConfig({ displayName: "StyledLink", componentId: "sc-oq93b2" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ", ";\n    outline: 0;\n  }\n"], ["\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ", ";\n    outline: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDark;
});
var Link = function (_a) {
    var _b = _a.href, href = _b === void 0 ? '_self' : _b, children = _a.children, rest = __rest(_a, ["href", "children"]);
    return (_jsx(StyledLink, __assign({ href: href }, rest, { children: children }), void 0));
};
export { Link };
var templateObject_1;
